export const attrsFromEntries = (tok) => {
    if (tok.attrs)
        return Object.fromEntries(tok.attrs);
    return {};
};
export function tryCatch(fn) {
    try {
        const result = fn();
        return { success: true, result };
    }
    catch (error) {
        console.error(error);
        return { success: false, error };
    }
}
